module.exports = __webpack_public_path__ + "img/carousel-next--purple.c4cc3e4a.svg";